<div class="payment-method">
  <!-- <mat-sidenav class="section-start" opened mode="side" position="end">
    <div class="container section-left">
      <div class="row">
        <div class="col-lg-12 nav-list" style="padding-right: 0px;margin-top:0px;">
          <h5>Options</h5>
          <ul>
            <li class="active">
              <a (click)="loadSetPayment()" href="javascript:">
                <svg fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round">
                  <use xlink:href="./assets/img/feather-sprite.svg#credit-card" />
                </svg>
                <span>Payment Method</span>
              </a>
            </li>
            <li>
              <a (click)="loadSetPayout()" href="javascript:">
                <svg fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round">
                  <use xlink:href="./assets/img/feather-sprite.svg#zap" />
                </svg>
                <span>Payout Method</span>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </mat-sidenav> -->
  <section class="container section-mid">
    <mat-tab-group class="mt-n4" dynamicHeight>
      <mat-tab label="Payment Method">
        <ng-container>
          <div class="row mt-4">
            <div class="col-lg-12 d-flex add-payment-method" (click)="setPaymentMethod()">
              <svg class="feather add-item plus-icon">
                <use xlink:href="/assets/img/feather-sprite.svg#plus" />
              </svg>
              <label>
                Add Payment method
              </label>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-12 payment-section">
              <label class="_Djaqe1" *ngFor="let card of stripeSource$ | async">
                <app-payment-option-list-item [card]="card" (clickedDeleteCard)="deleteCard($event)">
                </app-payment-option-list-item>
              </label>
            </div>
          </div>
        </ng-container>
      </mat-tab>
      <mat-tab label="Payout Method">
        <ng-container>
          <div class="payout">
            <div class="row mt-4">
              <div class="col-lg-12">
                <h4>
                  Payout methods
                </h4>
                <label class="subtitle">
                  Transfer rental income to your connected bank accounts through our secured payment system.
                </label>
              </div>
            </div>
            <br />
            <!-- TODO add payout accounts here -->
            <div class="rui-callout rui-callout--help accept-terms">
              <h2 style="font-weight: 400;font-size: 1.3rem;">
                <svg class="feather verified">
                  <use xlink:href="/assets/img/feather-sprite.svg#info" />
                </svg>
                Payout account(s)
              </h2>
              <ul class="stripe-acct-wrap" style="margin: 0px;">
                <!-- TODO add bank account number here -->
                <!-- handle click row edit/update details. -->
                <!-- TODO on create connected account, add name/email already -->
                <li *ngIf="(stripeAccountDetails)?.individual; else noAccount" (click)="openPayoutAccoutSettings()">
                  <div>
                    <!-- TODO show last 4 sa bank account -->
                    <h4>
                      {{ (stripeAccountDetails)?.individual.first_name }}
                      {{ (stripeAccountDetails)?.individual.last_name }}
                      <!-- TODO show id stripeAccountDetails.individual.verification.status -->
                      <!-- mao ni ang id -->
                      <!-- <span class="status-chip" *ngIf="(stripeAccountDetails)?.individual">PENDING</span> -->
                      <span class="status-chip red" *ngIf="showTermsButton(stripeAccountDetails)">PAYOUT DISABLED</span>
                    </h4>
                    <label class="added-info" *ngIf="(stripeAccountDetails)?.individual">
                      {{ (stripeAccountDetails)?.individual.email }}
                    </label>
                    <!-- TODO id upload -->
                    <!-- TODO show date last updated -->
                  </div>
                </li>
                <ng-template #noAccount>
                  <li (click)="openPayoutAccoutSettings()">
                    <div>
                      <!-- TODO show last 4 sa bank account -->
                      <h4>
                        No payout account
                      </h4>
                      <label class="added-info">
                        Create your payout account now.
                      </label>
                    </div>
                  </li>
                </ng-template>

                <!-- <li (click)="openAccountInfo()">
                  <div>
                    <h4>
                      <a style="padding-left: 10px;" href="javascript:">
                        Update Stripe Account
                      </a>
                    </h4>
                  </div>
                  <div>
                    <svg class="feather list-icon link">
                      <use xlink:href="./assets/img/feather-sprite.svg#chevron-right">
                      </use>
                    </svg>
                  </div>
                </li> -->
              </ul>
            </div>
          </div>
        </ng-container>
      </mat-tab>
    </mat-tab-group>
    <!-- <ng-container *ngTemplateOutlet="mainTemplateRef"></ng-container> -->
  </section>
</div>